export default __webpack_public_path__ + "static/media/icon11.410d305e.svg";